// import utilFunctions from "./utilFunctions"
import { t } from "../Utils/translate";

import config from "../Config/Config";
const strings = {
  navigation: {
    welcome: "/",
    zoomTest: "/zoom-test",
    hospitalLogin: "/hospital-login",
    doctorLogin: "/doctor-login",
    newPassword: "/new-password",
    doctorForgotPassword: "/doctor-forgot-password",
    hospitalForgotPassword: "/hospital-forgot-password",
    clinicRegister: "/clinic-register",
    dashboard: "/dashboard",
    digitalCard: "/digital-card",
    digitalCardEmployeeView: "/digital-card/:id",
    clinicOnboarding: "/clinic-onboarding",
    clinicProfile: "/clinic-profile",
    clinicTiming: "/clinic-timing",
    clinicConfiguration: "/clinic-configuration",
    addDoctor: "/add-doctor",
    approvedAppointment2: "/approved-appointment/:id",
    approvedAppointment: "/approved-appointment",
    appointmentApprove: "/appointment-aprove",
    appointmentRequest: "/appointment-request",
    report: "/report",
    referralTracker: "/referral-tracker",
    DoctorReferral: "/doctor-referral",
    DoctorReferralList: "/doctor-referral-list",
    updateReferralTracker: "/update-referral-tracker/:id",
    createAppointmentReferralTracker: "/create-appointment-referral-tracker",
    verifyMobileOTP: "/verify-mobile-otp",
    ePrescription: "/approved-appointment/e-prescription",
    forgotPassword: "/forgot-password",
    zoom: "/start-zoom-call",
    viewClinicProfile: "/profile",
    mobileOTP: "/mobile-otp",
    registerOTP: "/register-otp",
    doctorDashboard: "/doctor-dashboard",
    clinicDashboard: "/clinic-dashboard",
    manageDoctor: "/manage-doctor",
    doctorProfileView: "/doctor-profile",
    clinicReport: "/clinic-report",
    patientList: "/doctor-profile/patient-list",
    forbidden: "/forbidden",
    serverDown: "server-down",
    serverDown2: "server-down-ab",
    waivedOffAppointments: "/waived-off-appointments",
  },
  commonLayout: {
    termsConditions: "Terms and Conditions",
  },
  value: {
    edit_profile: "editProfile",
    edit_config: "editConfig",
    edit_timing: "editTiming",
    editClinicProfile: "editClinicProfile",
  },
  success: {
    edit_profile: "Hospital Profile details updated sucessfully",
  },
  welcome: {
    label_start: "Let's Start!",
    label_sub_message: "It's going to take only few minutes",
    label_iam: "I am",
    label_clinic_admin: "Clinic Admin",
    label_doctor: "Doctor",
    sign_up: " You can resend a OTP after",
  },
  validations: {
    label_empty_clinic_text_msg: "Clinic name should not be empty.",
    label_three_chars: "3 characters required.",
    max_hundred_chars: "Maximum characters allowed is 100.",
    empty_registration_field: "Hospital Registration number should not be empty.",
    label_only_numbers: "Only numbers allowed.",
    empty_mobile_field: "Mobile number should not be empty.",
    only_eight_numbers: "Only eight numbers allowed.",
    only_ten_numbers: "Only ten numbers allowed",
    min_eight: "Minimum required number is 8",
    max_twelve: "Maximum allowed number is 12",
    invalid_number: "Invalid phone number",
    empty_email_id: "EmailID should not be empty.",
    invalid_email: "Invalid Email",
    emptyClinicAddress: "Clinic address should not be empty.",
    eight_chars: "Minimum 8 characters required.",
    maxSeventy: "Maximum characters allowed is 70.",
    empty_zip_code: "Zip code should not be empty",
    clinic_address: "Clinic address should not be empty.",
    eightNumbers: "3 characters required.",
    zip_code: "Zip code should not be empty",
    number: "Only numbers allowed",
    password_empty: "Password should not be Empty",
    uppercase: "One UpperCase Letter required",
    lowercase: "Please use lower case letter",
    digit: "One digit required",
    special: "One Special Character required",
    password: "16 Characters Password required",
    username_empty: "User name should not be Empty",
    special_middle: "Enter Special Characters in Middle only",
    six_chars: "Minimum 6 characters required",
    twenty_chars: "Maximum 20 Characters required",
    hci_code: "HCI code should not be empty",
    character: "One Character is required",
    min_ten: "Minimum required number is 10",
    doctor_username: "Username should not be empty",
    minDoctorUsername: "Minimum 8 characters are required",
    minChars: "Minimum 4 characters required",
    startWithLetter: "username start with characters ",
    specialChars: "Underscore, dot & dash can't be next to each other and should not start or end with underscore, dot & dash ",
    allowedChars: "Username will allow only dot, dash, and underscore",
    mobileNumber: "Mobile number should not be empty.",
    specialityNameIsEmpty: "Speciality title should not be empty",
    onlyCharatersAllowed: "Speciality title allows only characters",
  },
  clinicLogin: {
    label_text: "Let's onboard your clinic on MyCLNQ-Provider",
    login_text: "Login to your Clinic",
    label_continue: "Continue",
    label_terms: "Terms and Conditions",
    label_onboard_register: "Onboard your clinic",
    label_mobile_verify: "Mobile Verification",
    label_sub_title_msg: "We have sent you an access code via SMS for Mobile Verification.",
    label_resend: "Resend OTP",
    label_to: "To",
    label_bottom: "bottom",
    label_verify: "Verify",
    label_session: "FV_sessionToken",
    label_hospital_Id: "FV_hospitalId",
    label_phone_number: "FV_phoneNumber",
    label_country_code: "FV_countryCode",
    label_hospital_address: "FV_hospitalAddress",
    label_clinic_name: "FV_clinicName",
    label_doctor_name: "FV_doctorName",
    label_doctor_name_en: "FV_doctorName_en",
    label_doctor_name_vi: "FV_doctorName_vi",
    label_login_type: "_isDoctor",
    label_auth_token: "Authorization",
    label_mobile_number: "Enter phone number*",
    label_mins: "mins",
    label_zero: "00:",
    label_get_otp: "Get OTP",
    label_already_login: "Already Registered ?",
    label_login: "Login",
    label_verify_number: "Verify phone number",
    label_onboard: "New clinic?",
    label_register: "Register",
    labelWeb: "WEB",
  },
  doctorLogin: {
    label_title: "Login as a Doctor",
    label_username: "Username",
    label_password: "Password",
    label_forgot_password: "Forgot Password",
    label_forgot: "Don't remember password?",
    forgot: "I don't remember password.",
    label_user_name: "User name",
    label_already_account: "Already have an account?",
    label_ok: "OK",
    label_popup_message: "We have sent you a link please check your inbox.",
    label_renter_password: "Confirm New Password",
    label_new_password: "Enter New Password",
    label_old_password: "Enter Current Password",
    label_confirm: "Confirm",
    label_create_password: "Create your new password",
    clinic_btn: " Login as a Clinic",
    doctor_label: "isDoctor",
    password: "Passwords mismatch",
    forgotPassword: "Forgot Password?",
  },
  clinicProfile: {
    label_logout: "Logout",
    label_profile: "Profile",
    label_timing: "Clinic Timing",
    label_configuration: "Configuration",
    label_add_doctor: "Add Doctor",
    label_clinic_profile_photo: "Hospital Profile photo",
    label_Consultation: "Configuration",
    label_clinic_name: "Clinic Name*",
    label_hospital_reg_no: "Hospital Registration Number*",
    label_emailid: "Email Address*",
    label_email_notification: "Email Notification",
    label_clinic_address: "Clinic Address*",
    labelLocationAddress: "Location Address*",
    labelTimezone: "Select Time Zone*",
    label_day: "Day",
    label_zip: "Zip Code*",
    label_session: "Session",
    label_clinic: "Clinic",
    label_doctor_name: "Doctor Name",
    label_qualification: "Qualification",
    label_specialization: "Speciality",
    label_mobile: "Mobile",
    label_notify: "Notification",
    labelConsultation: "Consultation",
  },
  clinicTiming: {
    label_sunday: "Sunday",
    label_monday: "Monday",
    label_tuesday: "Tuesday",
    label_wednesday: "Wednesday",
    label_thursday: "Thursday",
    label_friday: "Friday",
    label_saturday: "Saturday",
    label_previous: "Previous",
    label_next: "Next",
  },
  doctorTiming: {
    label_sunday: "Sunday",
    label_monday: "Monday",
    label_tuesday: "Tuesday",
    label_wednesday: "Wednesday",
    label_thursday: "Thursday",
    label_friday: "Friday",
    label_saturday: "Saturday",
  },
  clinicConfiguration: {
    label_video_consultation: "Video Consultation",
    label_zoom_id: "Enter the Zoom user Id here...",
    label_audio_consultation: "Audio Consultation",
    label_home_consultation: "Home Consultation",
    label_booking: "Booking",
    label_false: "false",
    label_true: "true",
    enable: "Enabled",
    disable: "Disabled",
    label_remote: "Remote Consult",
    label_e_prescription: "Generate E-prescription",
    label_on_board: "On Board",
    label_advanced_booking: "Advanced Booking",
    label_advanced_booking_limit: "Advanced Booking Limit",
    label_queue: "Queue",
    label_queue_system: "Queue System",
    label_queue_reset: "Queue Reset",
    label_queue_limit: "Queue Limit",
    update_success: "Clinic Configuration Details Updated Sucessfully",
    label_clinic: "Clinic",
    label_doctor: "Doctor",
    label_placeholder_clinic: "clinic",
    label_placeholder_doctor: "doctor",
    label_day: "Day",
    label_session: "Session",
    label_insurance: "Insurance",
    label_insurance_acceptance: "Insurance Acceptance",
    label_notification: "Notification",
    label_email_notification: "Email Notification",
    label_advanced: "Advanced",
    label_emr: "EMR",
    label_timezone: "Time Zone",
    label_address: "Clinic Address",
    generate_medical_certificate: "Generate Medical Certificate",
    label_cancel: "Cancel",
    label_upload: "Upload Clinic Logo",
    label_upload_stamp: "Upload Clinic Stamp",
    label_500px: "500px x 500px",
    label500px: "500px x 500px",
    label_medical_certificate: "Medical Certificate",
    label_enabled: "Enabled",
    label_emr_id: "EMR ID",
    label_video_call: "Video Call",
    label_house_call: "House Call",
    label_audio_call: "Telephone",
    label_board_popup: "  If you change the clinic level advance booking it will effect all the doctors in clinic",
    label_still_continue: " Still you want to Continue?",
    labelBoard: " Existing appointment will continue, but you will not be able to do advance booking",
    stamp_error: "Clinic logo is mandatory for Medical Certificate / E-Prescription",
    appointmentType: "As doctor you can't change appointment type please contact clinic admin",
    note: "Note",
    label300px: "300px x 150px",
  },
  addDoctor: {
    label_doctor_profile_photo: "Doctor profile photo",
    label_doctor_details: "Doctor Details",
    label_gender: "Gender",
    label_to: "To",
    label_emr: "HCR Code",
    label_male: "MALE",
    label_female: "FEMALE",
    label_add_phone_no: "Add phone number for patient vital alert",
    label_sign: "Select vital signs",
    label_work_experience: "Work Experience",
    label_years: "years",
    label_year: "year",
    label_month: "Month",
    label_months: "Months",
    label_years_months: "Present 2 years and 5 months",
    label_language: "Language",
    label_lang_example: "Eg: English, Hindi",
    label_booking: "Booking",
    label_advance_booking: "Advance Booking",
    label_calender_based: "Calender Based",
    label_medical_certificate: "Generate Medical Certificate",
    add_doctor_note_disable: "Note*: Enabling this will change the change the doctor's appointments" + "" + "to date wise.",
    add_doctor_note_enable: "Note*: Disabling this will change the change the doctor's appointments" + "" + "to date wise.",
    label_select_all: "Select All",
    label_select_notification: "Select Notification",
    label_vital: "Alert(you will be notified to your phone and email address)",
    label_doctorname_placeholder: "Doctor Name*",
    label_username_placeholder: "Username*",
    label_qualification_placeholder: "Qualification*",
    label_description_placeholder: "Description (Optional)",
    label_specialty_placeholder: "Select Specialty*",
    label_year_placeholder: "Select Year",
    label_month_placeholder: "Select Month",
    label_language_placeholder: "Select Language*",
    label_time_placeholder: "Select",
    label_heading_consultation: "Consultation",
    label_heading_audio: "Audio Consultation",
    label_heading_video: "Video Consultation",
    label_heading_house: "House Consultation",
    label_schedule: "Schedule",
    label_scheduled: "Scheduled",
    label_holiday_schedule: "Holiday Schedule",
    label_no_holidays: "No holidays in this month",
    label_no_insurance: "No Insurance",
    label_no_department: "No Departments",
    label_department: "Speciality",
    label_manage_doctor: "Manage Doctors",
    image_upload_Stamp_Photo: "DOCTOR_STAMP",
    append_image: "image",
    append_data: "data",
    upload_Signature_Photo: "DOCTOR_SIGNATURE",
    toastHolidayExist: "Holiday already exist",
    label_signature: "Upload Signature",
    label_upload_stamp: "Upload Stamp",
    mandatorDoctor: "Doctor signature is mandatory for Medical Certificate",
    month_cannot: "Can't select month greater than current month",
    label_format: "YYYY-MM-DD",
    label_from: "From",
    label_to: "To",
    doctorMCRNumber: "Doctor MCR Number*",
    addNumberForVital: "Add Number for Vital Sign Alert",
    addEmailForVital: "Add email id for Vital Sign Alert",
    doctorProfile: "Doctor Profile",
    labelMale: "Male",
    labelFemale: "Female",
    labelYears: " years",
    labelYear: " year",
    labelMonth: " Month",
    labelMonths: " Months",
    doctorAdded: "Doctor added successfully.",
    specialityEmpty: " Speciality should not be empty",
    languageEmpty: "Languages should not be empty.",
  },
  errorMsg: {
    invalid_credentials: "Username or password does match",
    otp_err: "please enter valid OTP",
    already_exist_err: "Already exist,try another number",
    expired_err: "OTP Expired",
    error: "Error",
    number_only: "Please enter only Number",
    ten_number_only: "Please enter only 10 digits number",
    eight_number_only: "Please enter only 8 digits number",
    zero_err: "Mobile number should not start from zero",
    eight_err: "Please enter between eight to twelve digit values",
    register_15_char_err: "Cannot exceed more than 15 numbers",
    zipCodeErr: "Number should be 4 to 10 digits.",
    zeroErr: "Zip code should not start with 0",
    invalidTimeOrSlot: "Invalid time or session entry",
    invalidDoctorTiming: "Doctor timing is not within clinic timings",
    sameNumber: "Number can't be same",
    appointmentIdIsInvalid: "Appointment id is invalid",
    proposeNewTimeNoAvailable: "You can't propose for next 30 minutes from current time",
    doctorNotAvailableForTheDate: "Doctor not available on the selected date. Please Propose new date and time",
    doctorNotAcceptingFuture: "Doctor not accepting appointment request for future dates",
    clinicNotWorking: "Clinic Not working on selected date, Please Propose New date and time",
    error_10001: "Invalid Credentials",
    error_10002: "Be patience with us. There is some technical glitch and we are working to resolve. Thanks for your understanding.",
    error_10003: "Please enter the missing field details.",
    error_10004: "Sorry, No user details found. Please sign-up first or click on find your user id",
    error_10005: "Sorry. No result found.",
    error_10006: "Sorry. Session got expired. Please re-login again",
    error_10007: "Your session got expired due to inactivity of 5 minutes. Please re-login",
    error_10008: "Sorry wrong OTP or your OTP expired. Please click on resend OTP and try",
    error_10022: "Doctor already exist with same mobile number",
    error_10009: "Sorry. Clinic does not accept advance booking.",
    error_10010: "Oops..Unfortunately, doctor is unavailable as per chosen time slot. Kindly change slot or date and try again.",
    error_10011: "Slot Duration Not Available",
    error_10012: "Shift Timings not Available",
    error_10013: "Sorry. You cannot book past days appointments. Please choose current or future date.",
    error_10014: "Oops. You took longer than usual.Session expired. Please re-login again",
    error_10015: "Sorry. Clinic does not accept advance booking.",
    error_10016: "Oops..Unfortunately, doctor is unavailable as per chosen time slot. Kindly change slot or date and try again.",
    error_10017: "This slot has already been booked. Please select another slot",
    error_10018: "Your Appointment has already being started",
    error_10019: "Oops..Unfortunately, doctor is unavailable as per chosen time slot. Kindly change slot or date and try again.",
    error_10019_calendar: "Oops..Unfortunately, doctor is unavailable as per chosen date. Kindly change date and try again.",
    error_10020: "Oops..Unfortunately, the clinic is unavailable as per chosen time slot. Kindly change slot or date and try again.",
    error_10020_calendar: "Oops..Unfortunately, the clinic is unavailable as per chosen date. Kindly change date and try again.",
    error_10021: "One User Self profile already exists for this user",
    error_10024: "Sorry, Maximum 6 profiles are only allowed per User",
    error_10025: "Sorry, Slot can't be booked because only one appointment is allowed per user in one session",
    error_Other: "Booking Unsuccessful due to some error",
    error_10029: "Sorry, You have entered the wrong NRIC number. Please check and try again",
    error_10028: "Sorry, User can't book more than one appointment on the same day at same time",
    error_10025_calendar: "Sorry, We can't send appointment request because only one appointment request is allowed per user in one session",
    error_10030: "Sorry, User with same name already exists in your profile.",
    error_10031: "Slot which you are trying to accept is already in use for another doctor for remote consultation.",
    pleaseFillAllTheFields: "Please fill all the fields",
    error_409: "Invalid Password",
    error_408: "Invalid Username",
    invalidNumber: "Invalid phone number",
    invalidNumberLengthSingapore: "Phone number must be 8 digits long",
    invalidNumberLengthIndia: "Phone number must be 10 digits long",
    invalidNumberLengthOther: "Phone number must be 12 digits long",
    clinicAdvanceMsg: "Clinic advance booking exceeded try some other date and time",
  },
  successMsg: {
    ePrescriptionGeneratedSuccessfully: "E-Prescription generated successfully",
    appointmentStarted: "Appointment started",
    forgot: "Updated password send to email",
    password: "Password updated successfully",
    otpSent: "OTP sent!",
    appointmentReassignedSuccessfully: "Appointment reassigned successfully",
  },
  appointment: {
    appointments: "Appointments",
    noAppointmentsMsg: "No appointments at this time",
  },
  detailsSidePanel: {
    Appointment_Details: "Appointment Details",
  },
  appointmentDetails: {
    checkVitalsSigns: "Check Vitals Signs",
    downloadMedicalCertificate: "Download Medical Certificate",
    medicalNotes: "Medical Notes",
    regenerateMedicalCertificate: "Regenerate Medical Certificate",
    patientHealthRecords: "Patient Health Records",
    generateMedicalCertificate: "Generate Medical Certificate",
    generateEPrescription: "Generate E-prescription",
    viewEPrescription: "View E-prescription",
    completed: "COMPLETED",
    started: "STARTED",
    medicalCertificate: "MEDICAL_CERTIFICATE",
    selectedFile: "Please select a file to upload",
    checkVitalSigns: "Check Vital Signs",
    actualRequestedTime: "Actual Requested Timing",
    patientHeight: "Height",
    patientWeight: "Weight : ",
    patientBMI: "BMI",
  },
  header: {
    clinicName: "Mishra Clinic",
    clinicLocation: "Cambridge Clinic",
    viewProfile: "View Profile",
    ePrescription: "E-Prescription",
    selectedMedicines: "Selected Medicines",
    orderDetails: "Order Details",
    appointmentRequests: "Appointment Requests",
    appointments: "Appointments",
    rejectAppointment: "Reject Appointment",
    approveAppointment: "Approve Appointment",
    proposeNewTime: "Propose New Time",
    consultationCharge: "Consultation Charge",
    reassignRequest: "Reassign Request",
    appointmentProposedTimings: "Appointment Proposed Timings",
    appointmentTiming: "Appointment Timing",
    patientAddress: "Patient Address",
    doctorUnavailable: "Doctor Unavailable",
    termsAndConditions: "Terms and Conditions",
    warning: "Warning",
    editTiming: "Edit Timing",
    viewPatients: "View Patients",
    patientList: "Patient List",
    vitalSigns: "Vital Signs",
    vitalSignsNotification: "Vital signs notification",
    selectNotification: "Select notification",
    vitals: "Vitals",
    lastAppointment: "Last appointment",
    loadingLanguage: "Loading Language",
    loadingWebsite: "Loading Website",
  },
  sideMenu: {
    dashboard: "Dashboard",
    appointment: "Appointment",
    appointmentRequest: "Appointment Request",
    report: t("report"),
    clinicProfile: "Hospital Profile",
    logout: "Log out",
    doctorProfile: "Profile",
  },
  placeholder: {
    searchMedicine: "Search medicine",
    noOfDays: "No. of days",
    noOfTablets: "Number of tablets",
    noOfBox: "Number of box",
    selectDosage: "Select dosage",
    patientIdentityNumber: "Patient NRIC/FIN/Passport no. (Optional)",
    typeToGetCountry: "Type to get country",
    noCountryFound: "No country found",
    locationAddress: "Location address*",
    hci_code: "Enter clinic HCI code",
    hh_mm: "HH:MM",
    doctorName: "Doctor name",
    active: "Active",
    typeYourMessage: "Type your message",
    rejectReason: "Reject reason",
    date: "DD/MM/YYYY",
    firstName: "First Name*",
    lastName: "Last Name*",
    phoneNumber: "Phone number",
    selectSymptomsAndEnterSymptoms: "Enter / Select Symptoms",
    address: "Address (Optional)",
    insuranceNumber: "Insurance number*",
    noDoctorsAvailable: "No doctors available",
    selectHours: "Select hour",
    selectMin: "Select min",
    addressNotAvailable: "Address not available",
    consultationCharge: "Consultation charge",
    search: "Search...",
    searchPatient: "Search Patient",
  },
  miscellaneous: {
    all: "All",
    doctorName: "Doctor name",
    medicineCost: "Medicine cost",
    deliveryCost: "Delivery cost",
    otherCost: "Other cost",
    totalAmount: "Total amount",
    doctor: "Doctor",
    today: "Today",
    yesterday: "Yesterday",
    tommorow: "Tommorow",
    date: "Date",
    time: "Time",
    consultType: "Consult Type",
    queueNumber: "Queue Number",
    patientNameIndicationHolder: " (Patient name)",
    yearsForAgeAndGender: " years, ",
    waiting: "Waiting",
    WAITING: "Waiting",
    waitingForPatient: "Waiting For Patient",
    doctorDetails: "Doctor Details",
    patientDetails: "Patient Details",
    appointmentTimingDetails: "Appointment Timing",
    symptoms: "Symptoms",
    timing: "Timing",
    appointmentStatus: "Appointment Status",
    hours: "Hours",
    mins: "Mins",
    hour: "Hour:",
    min: "Min:",
    insuranceHolder: "Insurance holder",
    availableDoctors: "Available doctors",
    locationLabelWithColon: "Location:",
    pending: "Pending",
    PENDING: "Pending",
    waitingForClinic: "Waiting for Clinic",
    doctor_pending: "Doctor Pending",
    patient_pending: "Patient Pending",
    previousWeek: "Previous Week",
    nextWeek: "Next Week",
    previousMonth: "Previous Month",
    nextMonth: "Next Month",
    fullView: "Full View",
    collapse: "Collapse",
    doctorIsNotAvailable: "Doctor is not available for selected date. Do you want to book appointment for next working day on ",
    clinicOnLeave: "Clinic is on leave. Do you want to book appointment for next working day on",
    doctorContinuouslyClosed: "DOCTOR_CONTINUESLY_CLOSED",
    clinicContinuouslyClosed: "CLINIC_CONTINUESLY_CLOSED",
    clinicAdvance: "CLINIC_ADVANCE_BOOKING_EXCEDED",
    doctorAdvance: "DOCTOR_ADVANCE_BOOKING_EXCEDED",
    doctorCoupleDaysUnavailable: "Doctor not available for couple of days.",
    years: "years",
    months: "months",
    days: "days",
    justBorn: "Just born",
    selectSlot: "Select Slot",
    cancelled: "Cancelled",
    CANCELLED: "Cancelled",
    houseCall: "HOUSE CALL",
    refundMsg: "Appointment Cancelled and Refund has been initated",
    hashMark: "#",
    editClinicTimingWarning: "All your future appointments will be cancelled and your doctors's timings will be aligned with clinic's timings",
    editDoctorTimingWarning: "All your future appointments will be cancelled",
    patient: "Patient",
    colon: ":",
    noVitalSignsAvailable: "No vital signs available",
    maximum: "Maximum",
    minimum: "Minimum",
    average: "Average",
    patientName: "Patient Name",
    gender: "Gender",
    age: "Age",
    lastCheck: "Last Check",
    na: "NA",
    intern: "Intern",
    lastProposedDoctor: "Last proposed time by doctor",
    lastProposedClinic: "Last proposed time by clinic",
    doctorProposed: "Doctor proposed",
    clinicProposed: "Clinic proposed",
    started: "Started",
    STARTED: "Started",
    requestedTime: "Requested time",
    ofExperience: " of experience",
    noPatientsAvailable: "No patients available",
    workingSession: "Working Session :",
    noSessionAvailable: "No session available",
    calendarCancelled: "Calendar cancelled",
  },
  time: {
    years: "years",
    months: "months",
    weeks: "weeks",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
    ago: "ago",
    justNow: "Just now",
  },
  vitalSigns: {
    diastolic: "Diastolic",
    Systolic: "Systolic",
  },
  notification: {
    label_today: "Today",
    label_yesterday: "Yesterday",
    leave: "Manage Leave",
    label_content: "John has sent an appointment request for Dr. Sandeep Mishra, schedule for 17/Jan/2023, at 12:00 AM",
  },
  format: {
    month: "MMM DD",
    date: "YYYY-MM-DD",
    fullYear: "YYYY",
    fullMonth: "MMMM",
    minute: " Mins",
    min: "M",
    DD: "DD",
    labelMin: "15 Mins",
    minValue: "15",
    MM: "MM",
    fullDate: "yyyy-MM-dd",
    formatDate: "YYYY MM DD",
    tomorrowMaxDate: "24 * 60 * 60 * 1000",
    maxDate: "90 * 24 * 60 * 60 * 1000)",
    appointmentDate: "DD-MM-YYYY",
  },
  btn: {
    createAppointment: "Create appointment",
    cancel: "Cancel",
    okay: "Okay",
    ok: "Ok",
    edit: "Edit",
    next: "Next",
    submit: "Submit",
    done: "Done",
    from: "From",
    to: "To",
    start: "Start",
    reassignRequest: "Reassign Request",
    reject: "Reject",
    proposeNewTime: "Propose New Time",
    approve: "Approve",
    propose: "Propose",
    select: "Select",
    close: "Close",
    waveOffAndAccept: "Waive off and Accept",
    waveOffAndPropose: "Waive off and Propose",
    accept: "Accept",
    confirm: "Confirm",
    details: "Details",
    finish: "Finish",
    openMap: "Open Map",
    delete: "Delete",
    create: "Create",
    createUsername: "Create Username",
    yes: "Yes",
    no: "No",
    save: "Save",
    saveChanges: "Save Changes",
    viewPatients: "View patients",
    selectVitalSigns: "Select vital signs",
    selectAll: "Select all",
    moreDetails: "More details",
  },
  vitalSignsNotificationOptions: {
    sms: "SMS",
    email: "Email",
    inApp: "In App",
  },
  checkboxOptions: {
    waiveOffFullPrice: "Waive-off-full-price",
    waiveOffDeliveryCharges: "Waive-off-delivery charges",
    medicinePurchasedFormClinic: "Medicine purchased form clinic",
  },
  viewProfile: {
    label_queue_limit: "Queue Limit",
    label_queue_reset: "Queue Reset",
    label_queue_system: "Queue System",
    label_queue: "Queue",
    label_contact: "Contacts",
    addReason: "Add leave details",
    labelManageLeave: "Manage Leave",
    label_doctor_popup: " Enter a unique username for the ",
    label_dr: "Dr.",
    leaveDetails: "Leave Details",
    view_department: " View Departments",
    reason: "your appointment is cancelled due to clinic unavailability sorry for the inconvenience",
    holidayExist: "holiday already exist",
    leaveSuccess: "leave added successfully",
    ask_to_delete: "Are You sure to delete the doctor ?",
    plus_icon: "+",
    ask_to_logout: "Are you sure you want to logout?",
    set_as_working: "Are you sure you want to cancel the leave?",
    doctorEmailId: "Email",
    labelProfile: "Edit Profile",
    cancelAppointment: "There are existing future Remote consult appointments confirmed.If you still want to go ahead, please cancel those appointments manually",
    cancelRemoteAppintment: "Cancel Remote Consult Appointment",
  },
  doctorProfile: {
    label_experience: "Experience",
    label_description: "Description",
    label_specialty: "Speciality",
    label_calender: "Calendar Based",
    label_enabled: "Enabled",
    label_disable: "Disabled",
    label_notification_type: "Notification Type",
    label_vital_contact: "Vital Alert Contact",
    label_vital_sign: "Vital Sign",
    label_vital_alert: "Vital Sign Alert",
    label_leave_schedule: "Leave Schedule",
    label_profile: "Profile",
    label_to: "To",
    label_sms: "SMS",
    label_inapp: "InApp",
    label_email: "Email",
    label_doctor_Profile: "Edit Profile",
    label_ReasonForLeave: "your appointment is cancelled due to doctor unavailability sorry for the inconvenience",
    label_change_password: "Change Password",
    label_title_doctor_Profile: "Doctor Profile",
    label_create_username: "Create Username",
    label_logout: "Logout",
    labelLeave: "Leave",
    leaveCancel: "Leave cancelled sucessfully.",
    labelManageLeave: "Manage Leave",
    changePassword: "Change Password",
    forgotPassword: "Forgot Password",
    takeTimeToUpdate: "Failed to update due network issue",
    password: "password",
    text: "text",
    manageDoctor: "Manage Doctors",
    oldPassword: "Current password should not be empty",
    newPassword: "New Password should not be empty",
    confirmPassword: "Confirm password should not be empty",
    doctorEmailId: "Enter email id of the doctor",
    doctorPasswordChangeSuccessMsg: "Doctor Password updated successfully,Please login again !",
  },
  generateCertificate: {
    certificateNumber: "Certificate number*",
    certificateName: "Display name in certificate*",
    patientAge: "Age of the patient*",
    remarks: "Remarks (Optional)",
    passportNumber: "NRIC/FIN/Passport*",
    referenceNumber: "Patient reference number*",
    certificateUsageLabel: "Certificate will be used for",
    work: "Work",
    college: "College",
    school: "School",
    period: "Period*",
    certificateNote: "Note: You cannot modify generated medical certificate",
    certificateGenerationMsg: "Certificate generated successfully",
  },
  medicalNotes: {
    docsName: "Medical Notes - ",
    image: "Image",
    pdf: "PDF",
    upload: "Click to upload",
    uploadNotes: "Upload notes",
    uploadInstructions: "Attach Images, PDF, E-Prescription",
    documentSuccessMsg: "Document uploaded successfully!",
    documentDeleteMsg: "Document deleted successfully!",
  },
  createAppointment: {
    calendar_based_schedule: "Schedule a calendar based appointment",
    appointment_calendar_based: "Calendar based appointment",
    label_no_raised_request: "No raised requests to display",
    emergency_booking: "Emergency Booking",
    radioMale: "Male",
    radioFemale: "Female",
    appointmentTimeNotAvailable: "You can't create appointment for next 30 minutes from current time.",
  },
  clinicDashboard: {
    pendingRequest: "Pending appointment requests ",
    takeAction: "Take Action",
    schedule: "Schedule",
    appointmentRequest: "Appointment Requests ",
    appointment: "Appointments",
    doctorAvailable: "Doctor Availability",
    patient: "Patient",
    doctor: "Doctor",
    timing: "Timing",
    action: "Action",
    selectAll: "select-all",
    labelApoointmentRequest: "appointmentRequest",
    labelAppointment: "appointment",
    labelDoctorAvailability: "doctorAvailability",
    long: "long",
    numeric: "numeric",
    enUs: "en-US",
    month: "month",
    checkbox: "checkbox",
    column1: "column1",
    column2: "column2",
    column3: "column3",
    invalidDate: "Invalid date",
    all: "All",
    videoCall: "Video call",
    audioCall: "Audio call",
    houseCall: "House call",
    telephone: "Telephone",
    slotBased: "Slot Based",
    noAppointmentRequest: " No Appointment Request at this time",
    noAppointment: " No Appointment at this time",
    noDoctorAvailable: "No doctor available Today",
    allDoctorAvailable: " All doctors are available today",
    working: "Working",
    onLeave: "On Leave",
    details: "Details",
    attend: "Attend",
    dashboard: "Dashboard",
    selectedDate: "Selected date is:",
    previous: "Previous Month",
    next: "Next Month",
    callTypeAll: null,
  },
  clinicReport: {
    thousand: "K",
    million: "M",
    billion: "B",
    week: "Week",
    month: "Month",
    year: "Year",
    custom: "Custom",
    smallFrom: "from",
    smallTo: "to",
    totalAppointments: "Total Appointments",
    requestedAppointments: "Requested appointments",
    completedAppointments: "Completed appointments",
    rejectedAppointments: "Rejected appointments",
    rejectedExpiredAppointments: "Rejected/Expired appointments",
    revenue: "Revenue",
    totalSlots: "Total slots",
    availableSlots: "Available slots",
    bookedSlots: "Booked slots",
    blockedSlots: "Blocked slots",
    selectDuration: "Select duration",
    clinicOverview: "Clinic Overview",
    doctorOverview: "Doctor Overview",
    currentYear: "Current Year",
    customDuration: "Custom duration",
    intern: "Intern",
    view: "View",
    age: "Age",
    type: "Type",
    status: "Status",
    consultFee: "Consult fee",
    export: "Export",
    patient: "Patient",
    phoneNo: "Phone no.",
    calendarBased: "Calendar based",
    slotBased: "Slot based",
    specialization: "Specialization",
    total: "Total: ",
    audio: "Audio",
    video: "Video",
    normal: "Digital/Walk-in",
    instantVideo: "Instant Video",
    capitalizeCompleted: "Completed",
    confirmed: "Confirmed",
    rejected: "Rejected",
    expired: "Expired",
    xls: "XLS",
    csv: "CSV",
    resetAll: "Reset All",
    selectFormat: "Select format",
    duration: "Duration",
    patientMobileNumberNA: "NA",
    plus: "+ ",
    noAppointment: "No appointment available",
    noRevenueAvailable: "No revenue available",
    pendingAppointment: "Pending Appointment Request",
    totalAppointment: "Total Appointment",
    approvedAppointment: "Approved Appointment",
    approvedAppointments: "Approved Appointments",
    pendingAppointments: "Pending Appointment Requests",
    waitingForPatient: "Waiting For Patient Confirmation",
  },
  errorCodes: {
    errorCode_10019: "10019",
    errorCode_10020: "10020",
  },
  noteAndWaring: {
    generatedEPrescriptionNote: "Note: You can't modify generated e-prescription",
    pleaseFillTheSlot: "Please fill the session",
    uploadDocumentsMsg: "You can only upload 5 documents",
    uploadedDocumentsMsg: "You have uploaded 5 documents",
    noUser: "NO USER AVAILABLE FOR THIS PHONE NUMBER",
    appointmentCancelled: "Appointment cancelled successfully",
    appointmentSuccess: t("Appointment created successfully"),
    meetingNotStarted: "Meeting not yet started",
    rejectAppointmentNote: "You are about to reject an appointment, Please specify the reason below to initiate communication.",
    approveAppointmentNotePart1: "You are about to confirm ",
    approveAppointmentNotePart2: "'s appointment request.",
    noRecordsFound: "No records found",
    proposeTimePart1: "has proposed new time for ",
    proposeTimePart2: "'s appointment request",
    noSlotsAvailable: "No slots available",
    cannotAccessFinishedCall: "Can't access the call, The call was already finished",
    appointmentAlreadyStarted: "Appointment already started",
    crossCountry: "This is a cross country request , Payment should be settled outside the system",
  },
  toastSucess: {
    doctorProfile: "Doctor profile update sucessfully",
  },
  firebase: {
    apiKey: "AIzaSyCpItHnjRN3UuVPV2hR3J53Es4ym88JfFw",
    authDomain: "myclnq-provider.firebaseapp.com",
    databaseURL: "https://myclnq-provider.firebaseio.com",
    projectId: "myclnq-provider",
    storageBucket: "myclnq-provider.appspot.com",
    messagingSenderId: "1538257958",
    appId: "1:1538257958:web:8e8d6ac1372bd1fe9ee2e7",
    vapidKey: "BLCvBO-Aa-g_JNRgL35OeUaeZdOic9FqebBo4WuBuIRye3dorX0zJkhwfqGOH-2yr_nL1H4Jndv7gdmhWasTW5c",
  },
  speciality: {
    labelSpeciality: "Speciality",
    placeholderSpeciality: "Type the specialty title here..",
    placeholderSpecialitySm: "Type...",
    viewSpeciality: "View Speciality",
    searchSpeciality: "Search speciality",
    searchSpecialitySm: "Search..",
    AlreadyExist: "AlreadyExist",
  },
};

strings.localStorage =
  config.baseURL === "https://stagingapi.myclnqhealth.com"
    ? {
        clinic_profile: "FV_isProfile",
        clinic_timing: "FV_isTiming",
        clinic_configuration: "FV_isConfig",
        clinic_add_doctor: "FV_isDoctorAdded",
        welcome: "FV_isWelcome",
        doctor: "FV_isDoctor",
        clinicDetails: "FV_clinicDetails",
        doctorDetails: "FV_doctorDetails",
        userId: "FV_user_id",
        false: "FV_false",
        doctorId: "FV_doctorId",
        deviceToken: "FV_deviceToken",
        countryCode: "FV_countryCode",
        doctorCount: "FV_doctorCount",
        ParticulardoctorId: "FV_docId",
        i18nextLng: "FV_i18nextLng",
        doctorName: "FV_doctorName",
        qualification: "FV_qualification",
        description: "FV_description",
        emailId: "FV_emailId",
        speciality: "FV_speciality",
        gender: "FV_gender",
        mobileNumber: "FV_mobileNumber",
        vitalMobileNumber: "FV_vitalMobileNumber",
        vitalEmailId: "FV_vitalEmailId",
        workExperienceInYear: "FV_workExperienceInYear",
        workExperienceInMonth: "FV_workExperienceInMonth",
        language: "FV_language",
        addVitalSwitch: "FV_addVitalSwitch",
        selectedMonthNumber: "FV_selectedMonthNumber",
        fcmToken: "FV_stage_fcm",
        deviceId: "FV_stage_fcm_deviceId",
      }
    : {
        clinic_profile: "FVisProfile",
        clinic_timing: "FVisTiming",
        clinic_configuration: "FVisConfig",
        clinic_add_doctor: "FVisDoctorAdded",
        welcome: "FVisWelcome",
        doctor: "FVisDoctor",
        clinicDetails: "FVclinicDetails",
        doctorDetails: "FVdoctorDetails",
        userId: "FVuser_id",
        false: "false",
        doctorId: "FVdoctorId",
        deviceToken: "FVdeviceToken",
        countryCode: "FVcountryCode",
        doctorCount: "FVdoctorCount",
        ParticulardoctorId: "FVdocId",
        i18nextLng: "i18nextLng",
        doctorName: "FVdoctorName",
        qualification: "FVqualification",
        description: "FVdescription",
        emailId: "FVemailId",
        speciality: "FVspeciality",
        gender: "FVgender",
        mobileNumber: "FVmobileNumber",
        vitalMobileNumber: "FVvitalMobileNumber",
        vitalEmailId: "FVvitalEmailId",
        workExperienceInYear: "FVworkExperienceInYear",
        workExperienceInMonth: "FVworkExperienceInMonth",
        language: "FVlanguage",
        addVitalSwitch: "FVaddVitalSwitch",
        selectedMonthNumber: "FVselectedMonthNumber",
        fcmToken: "FV_fcm",
        deviceId: "FV_fcm_deviceId",
      };

export default strings;
